module.exports = __webpack_public_path__ + "img/pd-img24.eeb4235c.png";